import React, { useContext, useEffect, useRef, useState } from "react";
import { AudioAppContext } from "../../../contexts/AudioContext";
import ButtonClickToUnmute from "./ButtonClickToUnmute";

export default function BackgroundVideoPlayerBrowserView({
  handleOnEnd,
  navigateToPageOnVideoEnd,
  source,
}) {
  const [canPlay, setCanPlay] = useState(false);
  const { videoMuted, setVideoMuted } = useContext(AudioAppContext)

  return (
    <>
      {canPlay && videoMuted && <ButtonClickToUnmute />}
      <video
        id="backgroundVideo"
        onEnded={handleOnEnd}
        className="view__video"
        playsInline
        loop={navigateToPageOnVideoEnd ? false : true}
        muted={videoMuted}
        onClick={() => setVideoMuted(!videoMuted)}
        autoPlay={true}
        onCanPlay={() => setCanPlay(true)}
        style={{
          backgroundColor: "transparent",
        }}
      >
        <source src={source} type="video/mp4" />
      </video>
    </>
  );
}
